import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock } from 'lucide-react';
import { CtaButton, scrollToPricing } from './Shared';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-2 pb-8 overflow-hidden bg-gradient-to-br from-teal-50 via-white to-cyan-50" data-id="element-60">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-61">
        <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-teal-100 rounded-full blur-3xl opacity-60" data-id="element-62"></div>
        <div className="absolute top-40 -left-20 w-96 h-96 bg-cyan-100 rounded-full blur-3xl opacity-50" data-id="element-63"></div>
        <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-emerald-100 rounded-full blur-3xl opacity-40" data-id="element-64"></div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-65">
        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-66">
          <div className="inline-block px-3 py-1 rounded-full bg-teal-100 text-teal-800 font-semibold text-xs md:text-sm mb-4 tracking-wide" data-id="element-67">
            KIT PSICOLOGÍA DEL INSOMNIO™
          </div>

          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-navy leading-tight mb-5" data-id="element-68">
            INTERVENÍ EN EL INSOMNIO DE TUS PACIENTES CON UN SISTEMA PRÁCTICO
          </h1>

          {/* Product Image - placed below the heading, reduced size */}
          <motion.div className="w-full max-w-[260px] md:max-w-[300px] mx-auto my-5 relative cursor-pointer" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} onClick={scrollToPricing} data-id="element-69">
            <div className="relative z-10 drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-70">
              <img src="https://cdn.magicpatterns.com/uploads/rgaVDBVW1QpFFPj37RZS9X/Diseno_sin_titulo_(30).png" alt="Kit Psicología del Insomnio" className="w-full h-auto object-contain" data-id="element-71" />
            </div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-teal-200/50 to-cyan-200/50 blur-3xl -z-10 rounded-full" data-id="element-72"></div>
          </motion.div>

          <p className="text-sm md:text-base text-slate-600 mb-5 leading-relaxed max-w-2xl mx-auto" data-id="element-73">
            El sistema para psicólogos que quieren abordar el insomnio dentro
            del tratamiento clínico con más claridad, estructura y herramientas
            aplicables desde la primera sesión.
          </p>

          <div className="flex flex-col items-center gap-3" data-id="element-74">
            <CtaButton className="w-full sm:w-auto text-base md:text-lg px-8 py-4" data-id="element-75">
              SÍ, QUIERO EL KIT AHORA
            </CtaButton>

            <div className="flex items-center gap-3 text-xs md:text-sm text-slate-500 font-medium" data-id="element-76">
              <span className="flex items-center gap-1.5" data-id="element-77">
                <Clock className="w-4 h-4 text-gold" data-id="element-78" /> Acceso inmediato
              </span>
              <span className="text-slate-300" data-id="element-79">•</span>
              <span className="flex items-center gap-1.5" data-id="element-80">
                <ShieldCheck className="w-4 h-4 text-gold" data-id="element-81" /> Pago único y
                seguro
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}